import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import WorkingTimeState, {WorkingTimeList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import httpRequest from '@/services/HttpRequestServiceWithToken'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<WorkingTimeState, State> = {
  async getWorkingTimeList(
    { commit, dispatch, state }: ActionContext<WorkingTimeState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'working-time', options, (res: WorkingTimeList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async postWotkingTime(
    { commit, dispatch, state }: ActionContext<WorkingTimeState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .postByLevel(process.env.VUE_APP_API_URL + '/v1', 'working-time', options, (res: object) => {
        commit(mutationType.CREATE, res)
      })
  },
  async putWotkingTime(
    { commit, dispatch, state }: ActionContext<WorkingTimeState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `working-time/${id}`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
  async deleteWotkingTime(
    { commit, dispatch, state }: ActionContext<WorkingTimeState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `working-time/${id}`, options, (res: object) => {
        commit(mutationType.DELETE, res)
      })
  },
}

export default actions
